import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom Manure Space specific variables
 */
export const parseManureSpaceEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Manure Space specific variables
  return {
    ...baseEnvironment,
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    FIELD_PLAN_URL: config.FIELD_PLAN_URL || '',
    USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES:
      config.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES === 'true',
    USE_LEGACY_MANURE_SPACE_ENDPOINT: config.USE_LEGACY_MANURE_SPACE_ENDPOINT === 'true',
    FIELD_ADVICE_REBUILD_DONE: config.FIELD_ADVICE_REBUILD_DONE === 'true',
    ARABLE_JOIN_DATA_REBUILD_DONE: config.ARABLE_JOIN_DATA_REBUILD_DONE === 'true',
  };
};
